import React from "react";
import styled from "@emotion/styled";
import BrandInfoCard from "@pages/brand/components/BrandInfoCard";
import { ShopListPanel } from "@pages/myPage/_component";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
});

const Brand = () => {
  return (
    <Container>
      <BrandInfoCard />
      <ShopListPanel haveFilter />
    </Container>
  );
};

export default Brand;
